import DemographicInfo from './DemographicInfo';

export default DemographicInfo;
